// ChangeColor.js
import * as THREE from 'three';

export default class ChangeColor {
    constructor(experience, camera, raycaster, sizes) {
        // this.cube = cube.cube; // Dunno why
        this.experience = experience;
        this.camera = camera;
        this.raycaster = raycaster;
        this.sizes = sizes;
        this.mouse = new THREE.Vector2();

        // Pass a callback to the World constructor
        // this.world = this.experience.world

        this.addEventListeners();
    }

    addEventListeners() {
        window.addEventListener('mousemove', (event) => this.onMouseMove(event), false);
        window.addEventListener('click', (event) => this.onClick(event), false);
    }

    onMouseMove(event) {
        // Convert the mouse position to normalized device coordinates
        this.mouse.x = (event.clientX / this.sizes.width) * 2 - 1;
        this.mouse.y = -(event.clientY / this.sizes.height) * 2 + 1;

        // Check for intersection with the cube
        this.checkIntersection();
    }

    checkIntersection() {
        // Update raycaster with mouse and camera
        this.raycaster.setFromCamera(this.mouse, this.camera);

        // Get intersections
        const intersects = this.raycaster.intersectObjects([this.cube]);

        // console.log(this.cube.material)

        // // Change cube color on hover
        if (intersects.length > 0) {
            this.cube.material.color.set(0xff0000); // Change color on hover
        } else {
            this.cube.material.color.set(0xa5bfd7); // Revert to original color
        }
    }

    onClick(event) {
        // Only process events on the canvas
        if (event.target.tagName !== 'CANVAS') return;

        // Update raycaster with mouse and camera
        this.raycaster.setFromCamera(this.mouse, this.camera);

        // Get intersections
        const intersects = this.raycaster.intersectObjects([this.cube]);

        // Handle cube click
        if (intersects.length > 0) {
            this.handleCubeClick(intersects[0].object);
        }
    }

    handleCubeClick(cube) {
        // Change color to blue on click
        cube.material.color.set(0x0000ff);
    }
}
